import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { WORDPRESS_URL } from "@constants";
import offerLogo from "@static/img/offer/data.png";
import { IOffer } from "../cart/ICart";
import { getLanguage } from "@utils/changeLanguage";

interface IParams {
    offer: IOffer;
    handleOfferClick(selectedOffer: IOffer): void;
}

const perks: string[] = ["package", "contract", "network"];

export const HomeOffer = (props: IParams) => {
    const {
        handleOfferClick,
        offer: { recurringChargeAmount },
    } = props;
    const { t } = useTranslation(["home", "glossary", "common"]);

    return (
        <Fragment>
            <div className="offer-home-price">
                <Typography align="center" color="inherit" variant="h1">
                    {t("common:price", { price: recurringChargeAmount })}
                </Typography>
                <Typography align="center" color="inherit" variant="body1">
                    {t("home:forLife")}
                </Typography>
                {/* <Typography align="center" color="inherit" variant="body1">
                    {t("home:promotionalOffer")}
                </Typography> */}
            </div>
            <Typography
                align="center"
                className="offer-home-price__hurry"
                color="inherit"
                gutterBottom
                variant="body1"
            />
            <Grid className="offer-home-items" container justify={"space-around"} spacing={2}>
                {perks.map((perk: string) => (
                    <Grid item key={perk} sm={4} xs={12}>
                        {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                        <img alt="item-image" className="offer-home-items__icon" src={offerLogo} />
                        <Typography color="inherit" variant="h6">
                            {t(`home:${perk}`)}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
            <Grid alignItems="center" className="offer-home-button" container direction="column">
                <Grid item md={4} sm={4} style={{ flex: "1 1 auto", display: "flex", justifyContent: "center" }} xs={6}>
                    <Button
                        className="xtest_tac_button"
                        color="secondary"
                        fullWidth
                        size="large"
                        style={{ padding: "17px 34px", fontSize: "0.9em"}}
                        variant="contained"
                        onClick={() => handleOfferClick(props.offer)}
                    >
                        {t("glossary:buyNow")} 
                    </Button>
                </Grid>
                <Grid item style={{ flex: "1 1 auto" }} xs={6}>
                    <Typography align="center" className="offer-home-items__conditions" color="inherit" variant="body2">
                        {t("home:fairUsageTerms")}
                    </Typography>
                    <Typography align="center" color="inherit" variant="body2">
                        {t("home:see")}
                        <Link
                            color="inherit"
                            href={`${WORDPRESS_URL}/${getLanguage()}/terms/#b5104db66cca049ff`}
                            rel="noopener"
                            target="_blank"
                            underline="always"
                        >
                            {t("home:otherCharges")}
                        </Link>
                        {t("home:and")}
                        <Link
                            color="inherit"
                            href={`${WORDPRESS_URL}/${getLanguage()}/terms/#8c304bd601c9e87f1`}
                            rel="noopener"
                            target="_blank"
                            underline="always"
                        >
                            {t("home:termsConditions")}
                        </Link>
                        {t("home:forMore")}
                    </Typography>
                </Grid>
            </Grid>
        </Fragment>
    );
};
